import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode
  icon?: ReactNode
  hint?: ReactNode
  error?: string
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, icon, hint, error, className, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold mb-1 block">
            {label}
          </label>
        )}
        <div className="relative">
          {icon && (
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
              {icon}
            </span>
          )}
          <input
            ref={ref}
            className={cn(
              'w-full px-3 py-2 border border-slate-300 rounded-md text-sm focus:border-amber-500 focus:outline-none transition',
              icon && 'pl-9',
              error && 'border-rose-400',
              className
            )}
            {...props}
          />
        </div>
        {hint && !error && <p className="text-[11px] text-slate-500 mt-1">{hint}</p>}
        {error && <p className="text-[11px] text-rose-600 mt-1">{error}</p>}
      </div>
    )
  }
)
Input.displayName = 'Input'
